import { render } from "./Image.vue?vue&type=template&id=b18d2a36&scoped=true"
import script from "./Image.vue?vue&type=script&lang=js"
export * from "./Image.vue?vue&type=script&lang=js"

import "./Image.vue?vue&type=style&index=0&id=b18d2a36&scoped=true&lang=css"

import exportComponent from "/home/oat/Desktop/ordi/corridor_v2/corridor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b18d2a36"]])

export default __exports__